import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { reconcileSessionRepository } from '@webapp/modules/accounts-payable/data-access/repositories/ReconcileSessionRepository'
import { CREDIT_CARD_ITEM_UNMATCHED_BASE_KEY } from '@webapp/modules/accounts-payable/query-configs/creditCardItemQueries'
import { RECONCILE_SESSION_MATCHES_BASE_KEY } from '@webapp/modules/accounts-payable/query-configs/reconcileSessionQueries'
import { STATEMENT_ITEM_UNMATCHED_BASE_KEY } from '@webapp/modules/accounts-payable/query-configs/statementItemQueries'

export const useMutateUnmatchMatch = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<void, RepoError, { matchId: number }>({
    mutationFn: ({ matchId }) =>
      reconcileSessionRepository.deleteMatch(matchId),
    onSuccess: () => {
      // Items return to the unmatched panes via invalidation (BHV-040).
      queryClient.invalidateQueries({
        queryKey: RECONCILE_SESSION_MATCHES_BASE_KEY,
      })
      queryClient.invalidateQueries({
        queryKey: CREDIT_CARD_ITEM_UNMATCHED_BASE_KEY,
      })
      queryClient.invalidateQueries({
        queryKey: STATEMENT_ITEM_UNMATCHED_BASE_KEY,
      })
    },
  })

  return {
    unmatchMatch: mutation.mutateAsync,
    isUnmatching: mutation.isLoading,
    error: mutation.error,
  }
}
